import { render, staticRenderFns } from "./IllegalReleaseList.vue?vue&type=template&id=2af6ba71&scoped=true&"
import script from "./IllegalReleaseList.vue?vue&type=script&lang=js&"
export * from "./IllegalReleaseList.vue?vue&type=script&lang=js&"
import style0 from "./IllegalReleaseList.vue?vue&type=style&index=0&id=2af6ba71&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af6ba71",
  null
  
)

export default component.exports